import moment from 'moment';
import angular from 'angular';
import template from './template.html';
import './style.scss';

export class CandidateCampaignStatus {
    autoContactRequestTooltip = '';

    /* @ngInject */
    constructor($filter) {
        this.$filter = $filter;
    }

    $onChanges() {
        const { campaignStatus } = this;

        if (campaignStatus) {
            const autoContactRequestDate = moment(new Date(campaignStatus.timestamp)).format('M/D/YYYY HH:mm');
            const translatedLabel = this.$filter('translate')('AUTO_CONTACT_REQUEST');

            this.autoContactRequestTooltip = `${autoContactRequestDate} ${translatedLabel}`;
        }
    }
}

export const CandidateCampaignStatusConfiguration = {
    template,
    bindings: {
        campaignStatus: '<',
    },
    controller: CandidateCampaignStatus,
    controllerAs: 'candidateCampaignStatus',
};

angular
    .module('TALENYA-FE')
    .component('candidateCampaignStatus', CandidateCampaignStatusConfiguration);
